import { Form, Radio, theme, Grid } from "antd";
import React from "react";
import unarousableSvg from "../../../../../../assets/images/scalesImages/FacewithSpiralEyes.png";
import deepSedationSvg from "../../../../../../assets/images/scalesImages/AnguishedFace.png";
import moderateSedationSvg from "../../../../../../assets/images/scalesImages/DizzyFace.png";
import lightSedationSvg from "../../../../../../assets/images/scalesImages/FaceExhaling.png";
import drowsySvg from "../../../../../../assets/images/scalesImages/SleepingFace.png";
import alertAndCalmSvg from "../../../../../../assets/images/scalesImages/SmilingFacewithSmilingEyes.png";
import restlessSvg from "../../../../../../assets/images/scalesImages/ExplodingHead.png";
import agitatedSvg from "../../../../../../assets/images/scalesImages/FacewithSteamFromNose.png";
import veryAgitatedSvg from "../../../../../../assets/images/scalesImages/AngryFace.png";
import combativeSvg from "../../../../../../assets/images/scalesImages/PoutingFace.png";
import unarousable from "../../../../../../assets/images/scalesImages/mobileImages/unarrousable.png";
import deepSedation from "../../../../../../assets/images/scalesImages/mobileImages/deepSedation.png";
import moderateSedation from "../../../../../../assets/images/scalesImages/mobileImages/moderateSedation.png";
import lightSedation from "../../../../../../assets/images/scalesImages/mobileImages/lightSedation.png";
import drowsy from "../../../../../../assets/images/scalesImages/mobileImages/drowsy.png";
import alertAndCalm from "../../../../../../assets/images/scalesImages/mobileImages/alertCalm.png";
import restless from "../../../../../../assets/images/scalesImages/mobileImages/restless.png";
import agitated from "../../../../../../assets/images/scalesImages/mobileImages/agiated.png";
import veryAgitated from "../../../../../../assets/images/scalesImages/mobileImages/veryAgitated.png";
import combative from "../../../../../../assets/images/scalesImages/mobileImages/combative.png";
const { useBreakpoint } = Grid;
const { useToken } = theme;
const getInterpretation = (val) => {
  switch (val) {
    case -5:
      return "No response to voice or physical stimulation";
    case -4:
      return "No response to voice, but any movement to physical stimulation";
    case -3:
      return "Any movement(but no eye contact) to voice";
    case -2:
      return "Briefly (less than 10 seconds) awakens with eye contact to voice";
    case -1:
      return "Not fully alert, but has sustained (more than 10 seconds) awakening, with eye contact, to voice";
    case 0:
      return "Spontaneously pays attention to caregiver";
    case 1:
      return "Anxious or apprehensive but movements not aggresive or vigorous";
    case 2:
      return "Frequent nonpurposeful movement or patient-ventilator dyssynchrony";
    case 3:
      return "Pulls on or removes tube(s) or catheter(s) or has aggresive behaviour toward staff";
    case 4:
      return "Overtly combative or violent; Immediate danger to staff";
  }
};
const RASScaleItems = ({ form, setRefresh }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const desktopOptions = [
  { value:-5, label:"Unarousable", image: unarousableSvg },
  { value:-4, label:"Deep Sedation", image: deepSedationSvg },
  { value:-3, label:"Moderate Sedation", image: moderateSedationSvg },
  { value:-2, label:"Light Sedation", image: lightSedationSvg },
  { value:-1, label:"Drowsy", image: drowsySvg },
  { value:0, label:"Alert and Calm", image: alertAndCalmSvg },
  { value:1, label:"Restless", image: restlessSvg },
  { value:2, label:"Agitated", image: agitatedSvg },
  { value:3, label:"Very Agitated", image: veryAgitatedSvg },
  { value:4, label:"Combative", image: combativeSvg },
];
const mobileOptions = [
  { value:-5, label:"Unarousable", image: unarousable },
  { value:-4, label:"Deep Sedation", image: deepSedation },
  { value:-3, label:"Moderate Sedation", image: moderateSedation },
  { value:-2, label:"Light Sedation", image: lightSedation },
  { value:-1, label:"Drowsy", image: drowsy },
  { value:0, label:"Alert and Calm", image: alertAndCalm },
  { value:1, label:"Restless", image: restless },
  { value:2, label:"Agitated", image: agitated },
  { value:3, label:"Very Agitated", image: veryAgitated },
  { value:4, label:"Combative", image: combative },
];
const rassOptions = isMobile ? mobileOptions : desktopOptions;
  const { token } = useToken();
  const handleRadioClick = (value) => {
    const currentValue = form.getFieldValue("rass_scale");
    form.setFieldValue("rass_scale", currentValue === value ? null : value);
    form.setFieldValue(
      "rass_interpretation",
      currentValue === value ? null : getInterpretation(value)
    );
    setRefresh((prev) => !prev);
  };
  return (
    <div className="physio-scales">
      <Form.Item name={"rass_interpretation"} hidden />
<Form.Item name="rass_scale">
  <Radio.Group className="radio-group rpe-grid">
    {rassOptions.map(option => {

      const selected =
        form.getFieldValue("rass_scale") === option.value;

      return (
        <Radio.Button
          key={option.value}
          value={option.value}
          onClick={()=>handleRadioClick(option.value)}
          style={{
            height:110,
            width:"100%",
            padding:0,
            display:"flex",
            justifyContent:"center",
            alignItems:"center",

            border: selected
              ? `2px solid ${token.colorPrimary}`
              : "1px solid #d9d9d9",

            background: selected
              ? token.colorPrimaryBg
              : "#fff",

            boxShadow: selected
              ? `0 0 0 2px ${token.colorPrimary}33`
              : "none",
          }}
        >

          <div className="visual-option">
            <img
              src={option.image}
              alt={option.label}
              className="visual-image"
            />

            <div className="visual-label">

              <div className={`rpe-badge badge-${option.value+6}`}>
                {option.value}
              </div>

              <div className="rpe-text">
                {option.label}
              </div>

            </div>
          </div>

        </Radio.Button>
      )
    })}
  </Radio.Group>
</Form.Item>

    </div>
  );
};

export default RASScaleItems;
